import _ from 'lodash';

export default {
  bind(el, binding) {
    const mapping = {
      upper: (str) => str.toUpperCase(),
      lower: (str) => str.toLowerCase(),
    };
    const handler = (e) => {
      const currentCase = binding.value.upper
        ? 'upper'
        : binding.value.lower
          ? 'lower'
          : null;
      if(_.isNull(currentCase)) return;
      const sourceVal = el.value;
      const newVal = mapping[currentCase](e.target.value);
      if(sourceVal === newVal) return;
      el.value = newVal;
      el.dispatchEvent(new Event('input', { bubbles: true })); // make sure the last character is updated
    };
    el.addEventListener('input', handler);
  },
};
